import React, {createContext, useContext, useEffect, useState} from "react";
import Api from "../util/Api";
import AppStorage, {StorageKey} from "../util/AppStorage";
import {UserType} from "../constants/enums";
import showBasicPopup from "../popups/showBasicPopup";

const PageDataContext = createContext(null);

export const PageDataProvider = ({children}) => {
    const [selectedSchoolYear, setSelectedSchoolYear] = useState(null);
    const [schoolYearsData, setSchoolYearsData] = useState([]);
    const [schoolYearOptions, setSchoolYearOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const isPupil = AppStorage.get(StorageKey.USER_TYPE) === UserType.PUPIL;

    useEffect(() => {
        if (!isPupil) {
            setSelectedSchoolYear(null);
            setSchoolYearsData([]);
            setSchoolYearOptions([]);
            setIsLoading(false);
            return;
        }

        setIsLoading(true);

        Api.get("users/me/schoolYears", (response) => {
            const data = response?.data;
            setSchoolYearsData(data);

            if (!data.length) {
                setSelectedSchoolYear(null);
                setSchoolYearOptions([]);
                setIsLoading(false);
                return;
            }

            const firstYear = data[0];
            setSelectedSchoolYear({
                value: firstYear.id,
                label: firstYear.title,
            });
            AppStorage.set(StorageKey.SCHOOL_YEAR_ID, firstYear.id);

            const newSchoolYearOptions = data.map((sy) => ({
                value: sy.id,
                label: sy.title,
            }));
            setSchoolYearOptions(newSchoolYearOptions);
            setIsLoading(false);
        }, null, null, () => {
            setIsLoading(false);
            setSchoolYearsData([]);
            setSchoolYearOptions([]);
            setSelectedSchoolYear(null);
            showBasicPopup("Ophalen van data opties mislukt!", "Er is iets mis gegaan met het ophalen van de data opties. Probeer het zometeen nog een keer.", "OK");
        }, {});
    }, [])

    const getDefaultSchoolYearValue = () => {
        if (isLoading || !selectedSchoolYear) {
            return null;
        }
        return selectedSchoolYear;
    }

    const handleSchoolYearChange = (value) => {
        setSelectedSchoolYear(value);
        AppStorage.set(StorageKey.SCHOOL_YEAR_ID, value.value);
    }

    const couldShowSchoolYearSelector = isPupil && !isLoading && selectedSchoolYear;
    const isSchoolYearContextReady = !isPupil || !isLoading; // Pupils must wait for school year to be in context

    return (
        <PageDataContext.Provider
            value={{
                selectedSchoolYear,
                setSelectedSchoolYear,
                schoolYearsData,
                setSchoolYearsData,
                schoolYearOptions,
                setSchoolYearOptions,
                getDefaultSchoolYearValue,
                handleSchoolYearChange,
                isLoading,
                couldShowSchoolYearSelector,
                isSchoolYearContextReady,
            }}
        >
            {children}
        </PageDataContext.Provider>
    );
}

export const usePageDataContext = () => useContext(PageDataContext);